import { render, staticRenderFns } from "./CardsSectionNewCopy.vue?vue&type=template&id=0d995852&scoped=true&"
import script from "./CardsSectionNewCopy.vue?vue&type=script&lang=js&"
export * from "./CardsSectionNewCopy.vue?vue&type=script&lang=js&"
import style0 from "./CardsSectionNewCopy.vue?vue&type=style&index=0&id=0d995852&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d995852",
  null
  
)

export default component.exports